import {
  ActivityApiResponse,
  ILesson,
  ILevel,
  LessonFormState,
  LessonsResponse,
  SingleApiResponse,
} from "./../types/index";
import { getFromMemory, saveToMemory } from "@utils/storage.utils";
import {
  getRequest,
  postRequest,
  updateRequest,
} from "./api-services/api-services";

import { API_URL } from "./config";
import { LevelResponse } from "src/types";
import showToast from "@utils/toast";

const currentLanguage = getFromMemory("language");

export const languageMap: Record<string, string> = {
  hausa: "HA",
  igbo: "IG",
  ["nigerian pidgin"]: "NP",
  swahili: "SW",
  wolof: "WF",
  yoruba: "YA",
};

interface ActivityApiSingleResponse {
  status: "success" | "error";
  result: { id: string };
}

export const listLevels = async (language: string): Promise<LevelResponse> => {
  const data = await getRequest<LevelResponse>(
    `${API_URL}/interactive-lessons/${language}/levels`,
  );
  return data;
};

export const fetchLevelByLevelId = async (
  levelId: string,
): Promise<SingleApiResponse<ILevel>> => {
  const data = await getRequest<SingleApiResponse<ILevel>>(
    `${API_URL}/levels/${levelId}`,
  );
  return data;
};

export const fetchLessonById = async (
  lessonId: string,
): Promise<SingleApiResponse<LessonFormState>> => {
  const data = await getRequest<SingleApiResponse<LessonFormState>>(
    `${API_URL}/lessons/${lessonId}`,
  );
  return data;
};

export const fetchLessonsByLevel = async (
  levelId: any,
  lang: string,
): Promise<LessonsResponse> => {
  const data = await getRequest<LessonsResponse>(
    `${API_URL}/interactive-lessons/${lang}/levels/${levelId}/lessons`,
  );
  return data;
};

export const fetchLessonQuestionsAndAnswers = async (
  lessonId: any,
  levelId: any,
  language: string,
): Promise<ActivityApiResponse> => {
  const data = await getRequest<ActivityApiResponse>(
    `${API_URL}/interactive-lessons/${language}/levels/${levelId}/lessons/${lessonId}/activities`,
  );
  return data;
};

export const newActivity = async (payload: any) => {
  const url = `${API_URL}/interactive-activities`;
  try {
    const request = await postRequest<ActivityApiSingleResponse>(url, payload);
    saveToMemory("lastActivityId", request.result.id);
    return request;
  } catch (error) {
    const message =
      error instanceof Error ? error?.message : "Apologies an error occured!";
    showToast(message, false);
  }
};

export const updateActivity = async (payload: any, activityId: string) => {
  const url = `${API_URL}/interactive-activities/${activityId}`;
  try {
    const request = await updateRequest<ActivityApiSingleResponse>(
      url,
      payload,
    );

    // Save the current activity ID to memory for future reference
    // saveToMemory("lastActivityId", request.result.id);
    return request;
  } catch (error) {
    const message =
      error instanceof Error ? error?.message : "Apologies an error occured!";
    showToast(message, false);
  }
};

export const fetchSupportedLanguage = async () => {
  const response = await getRequest<ActivityApiResponse>(
    `https://core.pluritongues.com/languages/supported-languages`,
  );

  return response;
};

export const fetchLevelsByLanguage = async () => {};
